import { Wrench, Sparkles, CircleDot, Zap, Truck } from "lucide-react";

export const CATEGORY_META = {
  mechanics: { name: "Mobile Mechanics", short: "Mechanics", Icon: Wrench, color: "#F59E0B" },
  valeting: { name: "Mobile Valeters", short: "Valeting", Icon: Sparkles, color: "#2563EB" },
  "tyre-repairs": { name: "Mobile Tyre Repairs", short: "Tyre Repairs", Icon: CircleDot, color: "#10B981" },
  electricians: { name: "Mobile Vehicle Electricians", short: "Electricians", Icon: Zap, color: "#A855F7" },
  recovery: { name: "Mobile Vehicle Recovery", short: "Recovery", Icon: Truck, color: "#EF4444" },
};

export const CATEGORY_ORDER = ["mechanics", "valeting", "tyre-repairs", "electricians", "recovery"];

export const TIER_STYLE = {
  gold: "bg-gradient-to-r from-amber-400 to-yellow-600 text-slate-950 shadow-md shadow-amber-500/25",
  silver: "bg-slate-600 text-slate-50 border border-slate-400",
  bronze: "bg-amber-900/70 text-amber-200 border border-amber-700/60",
  free: "bg-slate-800 text-slate-400 border border-slate-700",
};
